import NewOllieBox from '@web/components/NewToOllie/new-ollie-box.svg';
import { shared } from '../../config';

export const LoginProps = {
  heading: 'Log in',
  labelEmail: 'Email address',
  labelPassword: 'Password',
  labelLogin: 'Log in',
  labelContinue: 'Continue',
  placeholderEmail: 'yourname@email.com',
  forgotPasswordUrl: '/auth/forgot-password/',
  forgotPasswordLabel: 'Forgot Password?',
  canineCareUrl: '/faqs/',
};

export const NewToOllieProps = {
  heading: 'New to Ollie?',
  subheading: 'Get started by setting up an account now.',
  img: {
    src: NewOllieBox,
    alt: 'New to Ollie?',
  },
  getStartedUrl: '/onboarding/',
  getStartedText: 'Get Started',
};

export const URL_TOO_MANY_FAILED_LOGIN_ERROR = `http://local-www.${shared.SITE_NAME}/api/auth/error?error=TooManyFailedLoginAttempts&provider=login`;

export const URL_FAILED_LOGIN_ERROR = `http://local-www.${shared.SITE_NAME}/api/auth/error?error=FailedLogin&provider=login`;

export const CUSTOMER_TYPES = {
  204: 'shopify',
  422: 'legacy',
  404: 'not found',
};

export const CUSTOMER_DEFAULT_VALUES = {
  shopify: {
    email: '',
  },
  legacy: {
    email: '',
    password: '',
  },
};

export const getDefaultValues = customerType => {
  // defaultValues should always only be the email
  // field if it isn't a Legacy customer or if we
  // are still determining the login type
  if (customerType !== 'legacy') {
    return CUSTOMER_DEFAULT_VALUES.shopify;
  } else {
    return CUSTOMER_DEFAULT_VALUES.legacy;
  }
};
